import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { FaCheckCircle, FaExclamationTriangle, FaEnvelope } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';
import { authAPI } from '../services/api';
import './VerifyEmail.css';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email') || '';
  const token = searchParams.get('token') || '';
  const { isAuthenticated } = useAuth();

  const [status, setStatus] = useState('checking'); // checking | success | error
  const [message, setMessage] = useState('');
  const [resent, setResent] = useState(false);

  useEffect(() => {
    if (!email || !token) {
      setStatus('error');
      setMessage('Ce lien de confirmation est incomplet.');
      return;
    }

    authAPI.verifyEmail(email, token)
      .then((response) => {
        setStatus('success');
        setMessage(response.message || 'Adresse e-mail confirmée avec succès.');
      })
      .catch((err) => {
        setStatus('error');
        setMessage(err.message || 'Ce lien de confirmation est invalide ou a déjà été utilisé.');
      });
  }, [email, token]);

  const handleResend = async () => {
    try {
      await authAPI.resendVerificationEmail();
      setResent(true);
    } catch {
      // Requires being logged in; the link below covers that case.
    }
  };

  return (
    <div className="verify-email-page">
      <div className="verify-email-card">
        {status === 'checking' && (
          <>
            <div className="spinner" />
            <p>Vérification de votre e-mail...</p>
          </>
        )}

        {status === 'success' && (
          <>
            <FaCheckCircle className="verify-email-icon success" />
            <h1>E-mail confirmé</h1>
            <p>{message}</p>
            <Link to={isAuthenticated ? '/dashboard' : '/login'} className="btn-primary">
              {isAuthenticated ? 'Aller au tableau de bord' : 'Se connecter'}
            </Link>
          </>
        )}

        {status === 'error' && (
          <>
            <FaExclamationTriangle className="verify-email-icon error" />
            <h1>Lien invalide</h1>
            <p>{message}</p>

            {resent ? (
              <p className="verify-email-hint">
                <FaEnvelope /> Un nouvel e-mail de confirmation a été envoyé.
              </p>
            ) : isAuthenticated ? (
              <button type="button" className="btn-primary" onClick={handleResend}>
                Renvoyer l'e-mail de confirmation
              </button>
            ) : (
              <p className="verify-email-hint">
                Connectez-vous, puis demandez un nouvel e-mail depuis les paramètres du compte.
              </p>
            )}

            <Link to="/login" className="verify-email-back">Retour à la connexion</Link>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
